<div class="modal-header p-0 border-0">
  <div class="top">
    <div class="left-side">
      <i class="icon" [class]="iconClass"></i>

      <div class="title">
        <h2 class="h2-heading mb-0" [title]="header">{{ header }}</h2>
        <p class="sub-heading hide-empty" [title]="subheader">{{ subheader }}</p>
      </div>
    </div>

    <div class="right-side">
      <div class="steps-controls">
        <button
          type="button"
          class="btn btn-secondary btn-icon"
          [disabled]="isLoading()"
          (click)="close()"
        >
          <i class="icon ic-close-20"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-body">
  <ul class="actions-group list-unstyled">
    @for (actionsGroup of actionGroups; track actionsGroup) {
      <li class="actions-group-item">
        <p class="actions-group-title hide-empty">{{ actionsGroup.title }}</p>

        <ul class="action-panels list-unstyled">
          @for (action of actionsGroup.actions; track action.title) {
            <li class="action-panel-item">
              <button
                class="action-panel"
                [disabled]="action.disabled || isLoading()"
                (click)="onPlateClick(action)"
              >
                <div [hidden]="!action.iconClass">
                  <i [class]="'icon ' + action.iconClass"></i>
                </div>

                <div class="d-flex flex-column align-items-start justify-content-start gap-12">
                  <div class="action-panel-title">{{ action.title }}</div>
                  <div class="action-panel-description hide-empty">{{ action.description }}</div>
                </div>
              </button>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
</div>

